"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = LanguageProvider;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _LanguageContext = require("./LanguageContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// it provides the language context to app
function LanguageProvider(_ref) {
    var children = _ref.children,
        defaultLanguage = _ref.defaultLanguage;

    var _useState = (0, _react.useState)(defaultLanguage),
        _useState2 = (0, _slicedToArray3.default)(_useState, 2),
        userLanguage = _useState2[0],
        setUserLanguage = _useState2[1];

    var provider = {
        userLanguage: userLanguage || defaultLanguage,
        userLanguageChange: function userLanguageChange(selected) {
            var newLanguage = selected || userLanguage;
            setUserLanguage(newLanguage);
            // window.localStorage.setItem('rcml-lang', newLanguage);
        }
    };

    return _react2.default.createElement(
        _LanguageContext.LanguageContext.Provider,
        { value: provider },
        children
    );
}